import { Logger } from '@saviynt/common';

import { httpService } from '../../../http-service/httpService';
import { AXIOS_TIMEOUT_ERROR_MESSAGE } from '../../../http-service/serviceConstants';
import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
} from '../../../utils/constant';
import {
  SET_ACTION_COUNT_CHECK,
  SET_ACTION_ERROR,
  SET_ACTION_LOADING,
  SET_ACTION_MODAL_OPEN,
  SET_ACTION_RESET,
  SET_ACTION_SUCCESS,
  SET_ACTION_SUCCESS_ALERT_MESSAGE,
  SET_CERT_DETAILS_VIEW_CERT_AUTO_REVOKE_LIST,
  SET_CERT_DETAILS_VIEW_CERT_END_DATE,
  SET_CERT_DETAILS_VIEW_CERT_START_DATE,
  SET_CONSULT_ACTION_ASSIGNEE_LIST,
  SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR,
  SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING,
  SET_ENABLE_INDIVIDUAL_COMMENTS,
  SET_REASSIGN_CONFIG,
  SET_VERIFY_PARENT_ERROR,
  SET_VERIFY_PARENT_LOADING,
  SET_VERIFY_PARENT_MAP,
} from '../types';
import {
  URL_APPROVE_ACTION_API,
  URL_CONSULT_ACTION_API,
  URL_FETCH_USER_API,
  URL_REASSIGN_ACTION_API,
  URL_REJECT_ACTION_API,
  URL_REVOKE_ACTION_API,
  URL_VERIFY_PARENT_API,
} from '../urls';

export const setCertficationStartDate = (startDate) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_VIEW_CERT_START_DATE,
    payload: startDate,
  });
};

export const setCertficationEndDate = (endDate) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_VIEW_CERT_END_DATE,
    payload: endDate,
  });
};

export const setAutoRevokeList = (revokeList) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_VIEW_CERT_AUTO_REVOKE_LIST,
    payload: revokeList,
  });
};

export const setReassignCongfig = (reassignConfig) => (dispatch) => {
  dispatch({
    type: SET_REASSIGN_CONFIG,
    payload: reassignConfig,
  });
};

export const setBannerForConsultAndReassign = (payload) => (dispatch) => {
  dispatch({
    type: SET_ACTION_SUCCESS_ALERT_MESSAGE,
    payload,
  });
};

export const setIndividualComments = (commentsConfig) => (dispatch) => {
  dispatch({
    type: SET_ENABLE_INDIVIDUAL_COMMENTS,
    payload: commentsConfig,
  });
};

export const setIsAtLeastThreeActions =
  (isAtLeastThreeActions) => (dispatch) => {
    dispatch({
      type: SET_ACTION_COUNT_CHECK,
      payload: isAtLeastThreeActions,
    });
  };

export const setIsModalOpen = (modalState) => (dispatch) => {
  dispatch({
    type: SET_ACTION_MODAL_OPEN,
    payload: modalState,
  });
};

export const setConsultActionAssigneeLoading = (state) => (dispatch) => {
  dispatch({
    type: SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING,
    payload: state,
  });
};

export const getVarifyParentItemStatus = async (
  dispatch,
  actionData,
  currentChildObject
) => {
  const body = {
    certkey: actionData.certKey,
    cert_userkey: actionData.userKey,
    cert_entitlement_valuekey: actionData.entValueKey,
    cert_accountkey: actionData.accountKey,
    cert_rolekey: actionData.roleKey,
  };

  dispatch({ type: SET_VERIFY_PARENT_LOADING, payload: true });

  try {
    const response = await httpService.post(URL_VERIFY_PARENT_API, body);

    const formattedVarifyRes = [];

    const userData = response.data.userMap;
    const accountData = response.data.accountMap;

    if (userData) formattedVarifyRes.push(userData);

    if (accountData) formattedVarifyRes.push(accountData);

    if (formattedVarifyRes?.length > 0)
      formattedVarifyRes.push(currentChildObject);

    dispatch({
      type: SET_VERIFY_PARENT_MAP,
      payload: formattedVarifyRes,
    });

    return response.data;
  } catch (error) {
    dispatch({
      type: SET_VERIFY_PARENT_ERROR,
      payload: { error: error.message },
    });
    Logger.error('Error: ', Error(error.message));
    // Reset for the isActionError to allow alertbanner to check on next call
    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 1000);

    return { isSuccess: false, isLoading: false, error: error.message };
  }
};

export const getVarifyEOParentItemStatus = async (dispatch, actionData) => {
  const body = actionData;

  dispatch({ type: SET_VERIFY_PARENT_LOADING, payload: true });

  try {
    const response = await httpService.post(URL_VERIFY_PARENT_API, body);

    return response.data;
  } catch (error) {
    dispatch({
      type: SET_VERIFY_PARENT_ERROR,
      payload: { error: error.message },
    });
    Logger.error('Error: ', Error(error.message));
    // Reset for the isActionError to allow alertbanner to check on next call
    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 1000);

    return { isSuccess: false, isLoading: false, error: error.message };
  }
};

export const postTerminateUser = (actionData) => async (dispatch) => {
  const body = {
    certkey: actionData.certKey,
    cert_userkey: actionData.userKey,
    status: `${actionData.status}`,
  };

  if (actionData?.comments) {
    body.comments = actionData.comments;
  }

  dispatch({ type: SET_ACTION_LOADING });

  try {
    await httpService.post(URL_REVOKE_ACTION_API, body);

    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 2000);

    dispatch({ type: SET_ACTION_SUCCESS });

    return { isSuccess: true, isLoading: false };
  } catch (error) {
    dispatch({
      type: SET_ACTION_ERROR,
      payload: { error: error.message },
    });

    return { isSuccess: false, isLoading: false, error: error.message };
  }
};

export const decommissionEntitlement = (actionData) => async (dispatch) => {
  const body = {
    certkey: actionData.certKey,
    status: `${actionData.status}`,
    tabletoupdate: actionData?.tabletoupdate,
    cert_accountkey: actionData.accountKey || '0',
    cert_entitlement_valuekey: actionData.entValueKey,
  };

  if (actionData?.comments) {
    body.comments = actionData.comments;
  }

  dispatch({ type: SET_ACTION_LOADING });

  try {
    await httpService.post(URL_REVOKE_ACTION_API, body);

    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 2000);

    dispatch({ type: SET_ACTION_SUCCESS });

    return { isSuccess: true, isLoading: false };
  } catch (error) {
    dispatch({
      type: SET_ACTION_ERROR,
      payload: { error: error.message },
    });

    return { isSuccess: false, isLoading: false, error: error.message };
  }
};

export const postChangeEndDate = (actionData) => async (dispatch, getState) => {
  const { campaignType } = getState().certifications.details.core;
  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;
  let body = {};

  if (isEOCampaign) {
    body = actionData;
  } else {
    body = {
      certkey: actionData.certKey,
      cert_userkey: actionData.userKey,
      status: `${actionData.status}`,
    };

    if (!actionData?.accountKey) {
      body.extendedEndDate = actionData?.extendedEndDate;
    } else {
      body.cert_accountkey = actionData?.accountKey;
    }

    if (actionData?.comments) {
      body.comments = actionData.comments;
    }

    if (actionData?.entValueKey) {
      body.requestOrigin = 'UI';
      body.cert_entitlement_valuekey = actionData?.entValueKey;
      body.enddate = actionData?.extendedEndDate;

      delete body.extendedEndDate;
    }

    if (actionData?.certRoleKey) {
      body.cert_rolekey = actionData?.certRoleKey;
    }
  }

  dispatch({ type: SET_ACTION_LOADING });

  try {
    await httpService.post(URL_APPROVE_ACTION_API, body);

    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 2000);

    dispatch({ type: SET_ACTION_SUCCESS });

    return { isSuccess: true, isLoading: false };
  } catch (error) {
    dispatch({
      type: SET_ACTION_ERROR,
      payload: { error: error?.response?.data?.response || error.message },
    });

    return {
      isSuccess: false,
      isLoading: false,
      error: error?.response?.data?.response || error.message,
    };
  }
};

export const postRejectAction = (actionData) => async (dispatch) => {
  const body = {
    eid: actionData.eid,
    cert_accountkey: actionData.accountKey,
    certkey: actionData.certKey,
    cert_userkey: actionData.userKey,
    cert_entitlement_valuekey: actionData.entValueKey,
    status: `${actionData.status}`,
  };

  if (actionData?.comments) {
    body.comments = actionData.comments;
  }

  if (actionData?.certRoleKey) {
    body.cert_rolekey = actionData?.certRoleKey.toString();
  }

  // EO campaign
  if (actionData?.cert_entitlement_value2key) {
    body.cert_entitlement_value2key = actionData.cert_entitlement_value2key;
  }

  if (actionData?.tabletoupdate) {
    body.tabletoupdate = actionData?.tabletoupdate;
  }

  dispatch({ type: SET_ACTION_LOADING });

  try {
    await httpService.post(URL_REJECT_ACTION_API, body);

    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 2000);

    dispatch({ type: SET_ACTION_SUCCESS });

    return { isSuccess: true, isLoading: false };
  } catch (error) {
    dispatch({
      type: SET_ACTION_ERROR,
      payload: { error: error.message },
    });

    return { isSuccess: false, isLoading: false, error: error.message };
  }
};

export const reassignLineItem =
  (actionData, actionKind) => async (dispatch, getState) => {
    const body = { ...actionData };

    const { reassignConfigMap } = getState().certifications.details.lineActions;

    const { campaignType } = getState().certifications.details.core;
    const isEOCampaign =
      CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

    // remove assignee when default assignee selected
    if (body?.assignee === reassignConfigMap.defaultReassignee) {
      // eslint-disable-next-line no-param-reassign
      delete body.assignee;
    }

    if (body?.updateStatus) {
      delete body.updateStatus;
    }

    dispatch({ type: SET_ACTION_LOADING, payload: actionKind });

    try {
      let actionURL = actionData?.updateStatus ? 'reject' : 'reassign';

      if (isEOCampaign) {
        actionURL = actionData?.updateStatus ? 'revoke' : 'reassign';
      }

      const reassignResponse = await httpService.post(
        `${URL_REASSIGN_ACTION_API}/${actionURL}`,
        body
      );

      dispatch({ type: SET_ACTION_SUCCESS });

      const { data } = reassignResponse;
      const alertBannerPayload = { shouldShowBanner: false };

      const responseMsg = data?.response?.response || data?.response;

      if (responseMsg && typeof responseMsg === 'string') {
        alertBannerPayload.shouldShowBanner = true;
        alertBannerPayload.payload = {
          title: 'Success',
          description: responseMsg,
        };
      }

      setTimeout(() => {
        dispatch({ type: SET_ACTION_RESET });
      }, 2000);

      return { isSuccess: true, isLoading: false, alertBannerPayload };
    } catch (error) {
      let errorMsg = '';

      if (error?.response?.data?.response) {
        errorMsg = error.response.data.response;
      } else {
        errorMsg = error.message;
      }

      setTimeout(() => {
        dispatch({ type: SET_ACTION_RESET });
      }, 2000);
      dispatch({
        type: SET_ACTION_ERROR,
        payload: { error: errorMsg },
      });

      return { isSuccess: false, isLoading: false, error: error.message };
    }
  };

export const resetReassignLineItem =
  (actionData, actionKind) => async (dispatch) => {
    const body = actionData;

    dispatch({ type: SET_ACTION_LOADING, payload: actionKind });

    try {
      await httpService.post(URL_APPROVE_ACTION_API, body);

      dispatch({ type: SET_ACTION_SUCCESS });
      setTimeout(() => {
        dispatch({ type: SET_ACTION_RESET });
      }, 2000);

      return { isSuccess: true, isLoading: false };
    } catch (error) {
      let errorMsg = '';

      if (error?.response?.data?.response) {
        errorMsg = error.response.data.response;
      } else {
        errorMsg = error.message;
      }

      setTimeout(() => {
        dispatch({ type: SET_ACTION_RESET });
      }, 2000);
      dispatch({
        type: SET_ACTION_ERROR,
        payload: { error: errorMsg },
      });

      return { isSuccess: false, isLoading: false, error: error.message };
    }
  };

export const consultLineItem = (actionData, actionKind) => async (dispatch) => {
  const body = { ...actionData };

  dispatch({ type: SET_ACTION_LOADING, payload: actionKind });

  try {
    const consultResponse = await httpService.post(
      URL_CONSULT_ACTION_API,
      body
    );

    dispatch({ type: SET_ACTION_SUCCESS });
    const { data } = consultResponse;

    const alertBannerPayload = { shouldShowBanner: false };

    const responseMsg = data?.response?.response || data?.response;

    if (responseMsg && typeof responseMsg === 'string') {
      alertBannerPayload.shouldShowBanner = true;
      alertBannerPayload.payload = {
        title: 'Success',
        description: responseMsg,
      };
    }

    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 2000);

    return { isSuccess: true, isLoading: false, alertBannerPayload };
  } catch (error) {
    let errorMsg = '';

    if (error?.response?.data?.response) {
      errorMsg = error.response.data.response;
    } else {
      errorMsg = error.message;
    }

    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 2000);
    dispatch({
      type: SET_ACTION_ERROR,
      payload: { error: errorMsg },
    });

    return { isSuccess: false, isLoading: false, error: errorMsg };
  }
};

export const resetConsultLineItem =
  (actionData, actionKind) => async (dispatch) => {
    const body = actionData;

    dispatch({ type: SET_ACTION_LOADING, payload: actionKind });

    try {
      await httpService.post(URL_APPROVE_ACTION_API, body);

      dispatch({ type: SET_ACTION_SUCCESS });
      setTimeout(() => {
        dispatch({ type: SET_ACTION_RESET });
      }, 2000);

      return { isSuccess: true, isLoading: false };
    } catch (error) {
      let errorMsg = '';

      if (error?.response?.data?.response) {
        errorMsg = error.response.data.response;
      } else {
        errorMsg = error.message;
      }

      setTimeout(() => {
        dispatch({ type: SET_ACTION_RESET });
      }, 2000);
      dispatch({
        type: SET_ACTION_ERROR,
        payload: { error: errorMsg },
      });

      return { isSuccess: false, isLoading: false, error: errorMsg };
    }
  };

const performCertificationAction = async (dispatch, actionData) => {
  let body = null;

  if (actionData?.accountKey) {
    body = {
      certkey: actionData.certKey,
      cert_userkey: actionData.userKey,
      cert_entitlement_valuekey: actionData.entValueKey,
      cert_accountkey: actionData.accountKey,
      cert_rolekey: actionData.certRoleKey,
      status: `${actionData.status}`,
    };
  } else {
    body = {
      certkey: actionData.certKey,
      cert_userkey: actionData.userKey,
      cert_entitlement_valuekey: actionData.entValueKey,
      cert_rolekey: actionData.certRoleKey,
      status: `${actionData.status}`,
    };
  }

  // Start - Eo Campaign
  if (actionData?.tabletoupdate) {
    body.tabletoupdate = actionData.tabletoupdate.toString();
  }

  if (actionData?.cert_entitlement_value2key) {
    body.cert_entitlement_value2key = actionData.cert_entitlement_value2key;
  }
  // End - Eo Campaign

  if (actionData?.comment) {
    body.comments = actionData.comment;
  }

  dispatch({ type: SET_ACTION_LOADING });

  try {
    await httpService.post(URL_APPROVE_ACTION_API, body);

    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 2000);

    dispatch({ type: SET_ACTION_SUCCESS });

    return { isSuccess: true, isLoading: false };
  } catch (error) {
    dispatch({
      type: SET_ACTION_ERROR,
      payload: { error: error.message },
    });
    Logger.error('Error: ', Error(error.message));
    // Reset for the isActionError to allow alertbanner to check on next call
    setTimeout(() => {
      dispatch({ type: SET_ACTION_RESET });
    }, 1000);

    return { isSuccess: false, isLoading: false, error: error.message };
  }
};

export const postApproveUser = (actionData) => async (dispatch) =>
  performCertificationAction(dispatch, actionData);

export const postApprove = (actionData) => async (dispatch) =>
  performCertificationAction(dispatch, actionData);

export const getUsersList =
  (certKey, searchText) => async (dispatch, getState) => {
    const { consultActionAssignee } =
      getState().certifications.details.lineActions;

    const body = {
      certkey: certKey,
      offset: '0',
      max: '3000',
    };

    if (searchText) {
      // to search user by name
      body.sSearch = searchText;
    }

    if (!consultActionAssignee?.isLoading) {
      dispatch({
        type: SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING,
        payload: true,
      });
    }

    dispatch({
      type: SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR,
      payload: { error: null },
    });

    try {
      const { data } = await httpService.post(URL_FETCH_USER_API, body);

      if (data.resultsList) {
        dispatch({
          type: SET_CONSULT_ACTION_ASSIGNEE_LIST,
          payload: { data: data.resultsList },
        });
      } else {
        dispatch({
          type: SET_CONSULT_ACTION_ASSIGNEE_LIST,
          payload: { data: [] },
        });
      }
    } catch (error) {
      dispatch({
        type: SET_CONSULT_ACTION_ASSIGNEE_LIST_ERROR,
        payload: {
          error: error === AXIOS_TIMEOUT_ERROR_MESSAGE ? error : error.message,
        },
      });
    } finally {
      dispatch({
        type: SET_CONSULT_ACTION_ASSIGNEE_LIST_LOADING,
        payload: false,
      });
    }
  };
